// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_R3q","cls2":"common-cls2_kAJ common-cls1_R3q"};